export const latencyDistributionChart = (data = []) => {
  const percentiles = data.map(d => d.percentile || d.label);
  const values = data.map(d => d.value);

  return {
    tooltip: {
      trigger: 'axis',
      formatter: (params) => {
        const p = params[0];
        return `${p.name}<br/>${p.marker} ${p.seriesName}: <strong>${p.value}ms</strong>`;
      }
    },
    grid: {
      left: '3%',
      right: '3%',
      top: '10%',
      bottom: '8%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: percentiles,
      boundaryGap: false,
      axisLabel: { fontSize: 10 }
    },
    yAxis: {
      type: 'value',
      name: 'ms',
      axisLabel: { fontSize: 10 }
    },
    series: [{
      name: 'Latency',
      type: 'line',
      smooth: true,
      areaStyle: {
        opacity: 0.3,
        color: {
          type: 'linear',
          x: 0, y: 0, x2: 0, y2: 1,
          colorStops: [
            { offset: 0, color: '#722ed1' },
            { offset: 1, color: 'rgba(114, 46, 209, 0.05)' }
          ]
        }
      },
      data: values,
      itemStyle: { color: '#722ed1' },
      lineStyle: { width: 2.5 },
      markLine: {
        silent: true,
        data: [
          { yAxis: 200, label: { formatter: 'SLO: 200ms', fontSize: 10 }, lineStyle: { color: '#52c41a', type: 'dashed' } },
          { yAxis: 500, label: { formatter: 'Warning: 500ms', fontSize: 10 }, lineStyle: { color: '#faad14', type: 'dashed' } }
        ]
      }
    }]
  };
};
